module.exports = __webpack_public_path__ + "img/earth_atmos_2048_edited.4bb67add.jpg";